/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges } from '@angular/core';
import { ReportContentTabularComponent } from './report-content-tabular.component';
import { IsolatedReportService } from '../../services/isolatedReport.service';
import { Store } from '@ngxs/store';
import { DataFormService } from '../../services/dataform.service';
import { LoggerService } from '../../../shared/services/logger.service';

@Component({
    selector: 'dash-gis-report-content-print-tabular',
    templateUrl: './report-content-print-tabular.component.html',
    styleUrls: ['./report-content-print-tabular.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportContentPrintTabularComponent extends ReportContentTabularComponent {
    constructor(
        logger: LoggerService,
        isolatedReport: IsolatedReportService,
        store: Store,
        dataFormService: DataFormService
    ) {
        super(logger, isolatedReport, store, dataFormService);
    }

    protected updateColumnsToDisplay() {
        this.columnsToDisplayCache = this.definition.fields.filter((f) => !f.hidden && !f.disablePrint).map((f) => f.name);
    }
}
